export interface IParametro {
  id: number;
  codParametro: string;
  codTipo?: string;
  desParametro?: string;
  active: boolean;
  selected: boolean;
}

export const enum ParametroTipoExportacion {
  EXCEL = "EXCEL",
  PDF = "PDF",
  TXT = "TXT",
  INFORME_COMPRAS = "INFORME_COMPRAS",
  INFORME_VENTAS = "INFORME_VENTAS",
  INSTRUCCIONES_COMPRA = "INSTRUCCIONES_COMPRA",
}

export const ParametroTipoExportacionByOneCliente: string[] = [
  ParametroTipoExportacion.INFORME_COMPRAS,
  ParametroTipoExportacion.INFORME_VENTAS,
  ParametroTipoExportacion.INSTRUCCIONES_COMPRA,
];
